<template>
  <header class="header">
    <h1>todos</h1>
    <UndoRedoControls namespace="todoList" />
    <input
      v-model="newTodo"
      class="new-todo"
      autofocus
      autocomplete="off"
      placeholder="What needs to be done?"
      @keyup.enter="addTodo"
    >
  </header>
</template>

<script>
import { mapActions } from "vuex";
import UndoRedoControls from "./UndoRedoControls";

export default {
  components: {
    UndoRedoControls
  },
  data() {
    return {
      newTodo: ""
    };
  },
  methods: {
    ...mapActions("todoList", {
      addTodoToStore: "addTodo"
    }),
    addTodo() {
      const value = this.newTodo && this.newTodo.trim();
      this.addTodoToStore(value);
      this.newTodo = "";
    }
  }
};
</script>
